var AccordionBlock = /** @class */ (function () {
    function AccordionBlock(element) {
        this.accordionBlock = element;
        this.accordionItems = Array.from(this.accordionBlock.querySelectorAll('.accordion-list-item'));
        this.addEventListeners();
    }
    AccordionBlock.prototype.addEventListeners = function () {
        var _this = this;
        this.accordionItems.forEach(function (accordionItem) {
            var accordionItemHeader = accordionItem.querySelector('.accordion-list-item-header');
            accordionItemHeader.addEventListener('click', _this.toggleAccordionItem.bind(_this));
        });
    };
    AccordionBlock.prototype.toggleAccordionItem = function (event) {
        var currentItem = event.currentTarget;
        var accordionItem = currentItem.parentElement;
        var accordionContentIsOpen = accordionItem.classList.contains('active');
        if (accordionContentIsOpen) {
            accordionItem.classList.remove('active');
        }
        else {
            accordionItem.classList.add('active');
        }
    };
    return AccordionBlock;
}());
var accordionBlocks = document.querySelectorAll('[data-accordion-block]');
accordionBlocks.forEach(function (accordionBlock) {
    new AccordionBlock(accordionBlock);
});
